import {
  AfterViewInit,
  Component,
  TemplateRef,
  ViewChild
} from '@angular/core';
import { BaseTableComponent } from '../../../../shared/tables/base-table/base-table';
import {
  DateUtil,
  HeroEventListResponseDto,
  HeroEventRecurrenceEnum,
  PrivilegeEnum
} from '@whetstoneeducation/hero-common';
import { HeroEventListColumnsEnum } from '../hero-event-list-models/hero-event-list-columns.enum';
import { AppPrivilegesService } from '../../../auth/privileges.service';

@Component({
  selector: 'app-hero-event-list-table',
  templateUrl: './hero-event-list-table.component.html',
  styleUrls: ['./hero-event-list-table.component.scss']
})
export class HeroEventListTableComponent
  extends BaseTableComponent<HeroEventListResponseDto>
  implements AfterViewInit
{
  @ViewChild('actionButtons') actionButtons: TemplateRef<any>;
  @ViewChild('activePill') activePill: TemplateRef<any>;
  public templates: { [key: string]: TemplateRef<any> } = {};
  public showPagination: boolean;

  constructor(public privilegesService: AppPrivilegesService) {
    super({ privilegesService });
    this.showPagination = this.dataArr?.length < this.tableFilters?.count;
  }

  ngAfterViewInit(): void {
    if (this.actionButtons) {
      this.templates['actionButtons'] = this.actionButtons;
    }
    if (this.activePill) {
      this.templates['activePill'] = this.activePill;
    }
  }

  public get displayedColumns() {
    return Object.values(HeroEventListColumnsEnum);
  }

  public columns = HeroEventListColumnsEnum;
  public columnValues = {
    [HeroEventListColumnsEnum.EVENT_ID]: ['id'],
    [HeroEventListColumnsEnum.EVENT_NAME]: ['name'],
    [HeroEventListColumnsEnum.EVENT_CATEGORY]: ['eventCategory'],
    [HeroEventListColumnsEnum.NEXT_EVENT]: ['nextScheduledHeroEvent'],
    [HeroEventListColumnsEnum.ACTIVE]: ['active'],
    [HeroEventListColumnsEnum.ACTION]: ['action']
  };

  public getColumnValue(column: string, row: HeroEventListResponseDto): any {
    switch (column) {
      case HeroEventListColumnsEnum.EVENT_ID:
        return row.id;
      case HeroEventListColumnsEnum.EVENT_NAME:
        return row.name;
      case HeroEventListColumnsEnum.EVENT_CATEGORY:
        return row.eventCategory;
      case HeroEventListColumnsEnum.NEXT_EVENT:
        return row.nextScheduledHeroEventTimestamp
          ? DateUtil.convertToDisplayDate(row.nextScheduledHeroEventTimestamp)
          : '';
      case HeroEventListColumnsEnum.RECURRENCE:
        switch (row.recurrence) {
          case HeroEventRecurrenceEnum.DAILY:
            return 'Daily';
          case HeroEventRecurrenceEnum.WEEKLY:
            return 'Weekly';
          case HeroEventRecurrenceEnum.ONE_TIME:
            return 'One-Time';
          case HeroEventRecurrenceEnum.MONTHLY:
            return 'Monthly';
          default:
            return '';
        }
      case HeroEventListColumnsEnum.ACTIVE:
        return {
          context: {
            active: row.active
          },
          template: this.templates.activePill
        };
      case HeroEventListColumnsEnum.ACTION:
        return {
          context: {
            heroEventId: row.id,
            active: row.active,
            ...(DateUtil.isToday(row.nextScheduledHeroEventTimestamp)
              ? { nextScheduledHeroEventId: row.nextScheduledHeroEventId }
              : {})
          },
          template: this.templates.actionButtons
        };
    }
  }

  protected readonly PrivilegeEnum = PrivilegeEnum;
  protected readonly DateUtil = DateUtil;
}
